import { Harpic, checkDocument } from '../../customLib';

const getSafetyChecklistLR = () => {
	let safetyChecklist = false;

	try {
		if (checkDocument()) {
			safetyChecklist =
				!!window.localStorage.getItem('safetyFirst') &&
				Harpic(
					window.localStorage.getItem('safetyFirst')
				).toLowerCase() === 'true';
		}
	} catch (err) {
		console.log(err);
	}

	return safetyChecklist;
};

export const initialSafetyShown = {
	safetyShown: getSafetyChecklistLR(),
};

const __toggleSafetyMsg = () => {
	if (checkDocument()) {
		window.localStorage.setItem('safetyFirst', 'true');
	}

	return {
		safetyShown: true,
	};
};

export const safetyChecklistActions = {
	__toggleSafetyMsg,
};
